import { render, staticRenderFns } from "./Center.vue?vue&type=template&id=3420c346&scoped=true&"
import script from "./Center.vue?vue&type=script&scoped=true&lang=js&"
export * from "./Center.vue?vue&type=script&scoped=true&lang=js&"
import style0 from "./Center.vue?vue&type=style&index=0&id=3420c346&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3420c346",
  null
  
)

export default component.exports